import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as drawerTypes from 'types/drawer';
import CatchError from 'components/CatchError';
import Firebase from 'utils/firebase';

import DrawerInvitations from './Invitations/container';
import DrawerSearch from './Search/container';
import DrawerCreateUnicastFeed from './CreateUnicastFeed/container';
import DrawerAddContacts from './AddContacts/container';
import DrawerSip from './Sip/container';
import DrawerEditGroup from './EditGroup/container';

class DrawerManager extends PureComponent {
    render() {
        const { type } = this.props;
        let Component = null;

        switch (type) {
            case drawerTypes.DRAWER_INVITE_EXTERNAL_EMAILS:
                Firebase.setCurrentScreen('DrawerInvitations');
                Component = DrawerInvitations;
                break;
            case drawerTypes.DRAWER_SEARCH:
                Firebase.setCurrentScreen('DrawerSearch');
                Component = DrawerSearch;
                break;
            case drawerTypes.DRAWER_CREATE_UNICAST:
                Firebase.setCurrentScreen('DrawerCreateUnicastFeed');
                Component = DrawerCreateUnicastFeed;
                break;
            case drawerTypes.DRAWER_SIP:
                Firebase.setCurrentScreen('DrawerSip');
                Component = DrawerSip;
                break;
            case drawerTypes.DRAWER_ADD_MEMBERS:
                Firebase.setCurrentScreen('DrawerAddContacts');
                Component = DrawerAddContacts;
                break;
            case drawerTypes.DRAWER_EDIT_GROUP:
                Firebase.setCurrentScreen('DrawerEditGroup');
                Component = DrawerEditGroup;
                break;
            default:
                return null;
        }

        if (Component) {
            return (
                <CatchError>
                    <Component />
                </CatchError>
            );
        }

        return null;
    }
}

DrawerManager.propTypes = {
    type: PropTypes.string
};

export default DrawerManager;
